module.exports = __webpack_public_path__ + "assets/img/ty9.071a1e74.jpg";